// 📄 Sistema de Prescripciones Médicas - Ojitos Pajaritos
// Versión ULTRA SIMPLE: Solo validación y feedback visual
// NO interfiere con el envío del formulario

class PrescriptionUpload {
  constructor() {
    this.init();
  }

  init() {
    // Solo vincular funciones para UI
    window.handlePrescriptionChange = this.handlePrescriptionChange.bind(this);
    window.removePrescription = this.removePrescription.bind(this);
    
    // Añadir estilos
    this.addStyles();
    
    console.log('✅ Sistema de prescripciones inicializado (NO interfiere con formulario)');
  }

  handlePrescriptionChange(input) {
    const file = input.files[0];
    const statusDiv = document.getElementById('prescription-status');
    const filenameSpan = document.getElementById('prescription-filename');
    const buttonText = document.getElementById('prescription-button-text');

    if (!file) {
      // No hay archivo - ocultar estado
      if (statusDiv) statusDiv.style.display = 'none';
      if (buttonText) buttonText.textContent = 'Subir mi receta médica';
      return;
    }

    // Validar archivo (solo frontend, no bloquea envío)
    if (!this.validateFile(file)) {
      input.value = ''; // Limpiar selección si es inválido
      return;
    }

    // Mostrar estado de archivo seleccionado (solo UI)
    if (statusDiv) {
      statusDiv.style.display = 'block';
    }
    if (filenameSpan) {
      filenameSpan.textContent = file.name;
    }
    if (buttonText) {
      buttonText.textContent = 'Cambiar receta médica';
    }

    console.log(`✅ Archivo seleccionado: ${file.name} (${this.formatFileSize(file.size)})`);
    console.log('📝 El archivo se enviará automáticamente con el formulario');
  }

  validateFile(file) {
    const maxSize = 20 * 1024 * 1024; // 20MB
    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'];
    const allowedExtensions = ['.jpg', '.jpeg', '.png', '.pdf'];

    const fileExtension = '.' + file.name.split('.').pop().toLowerCase();
    const validationErrors = [];

    // Validaciones básicas
    if (file.size === 0) {
      validationErrors.push('❌ El archivo está vacío');
    } else if (file.size > maxSize) {
      validationErrors.push(`❌ Archivo muy grande: ${this.formatFileSize(file.size)}\n   Máximo: 20MB`);
    }

    if (!allowedExtensions.includes(fileExtension)) {
      validationErrors.push(`❌ Extensión no válida: ${fileExtension}\n   Permitidas: JPG, PNG, PDF`);
    }

    if (!allowedTypes.includes(file.type)) {
      validationErrors.push(`❌ Tipo no válido: ${file.type}`);
    }

    // Mostrar errores si los hay
    if (validationErrors.length > 0) {
      alert(`🚫 ARCHIVO NO VÁLIDO\n\n${validationErrors.join('\n')}\n\n📋 Solo se permiten: JPG, PNG, PDF (máximo 20MB)`);
      return false;
    }

    return true;
  }

  removePrescription() {
    const fileInput = document.getElementById('prescription-file');
    const statusDiv = document.getElementById('prescription-status');
    const buttonText = document.getElementById('prescription-button-text');

    // Limpiar input
    if (fileInput) fileInput.value = '';

    // Ocultar estado
    if (statusDiv) statusDiv.style.display = 'none';

    // Restaurar texto
    if (buttonText) buttonText.textContent = 'Subir mi receta médica';

    console.log('🗑️ Archivo removido');
  }

  formatFileSize(bytes) {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  }

  addStyles() {
    if (document.querySelector('#prescription-upload-styles')) return;

    const style = document.createElement('style');
    style.id = 'prescription-upload-styles';
    style.textContent = `
      .prescription-upload-label {
        display: inline-flex;
        align-items: center;
        gap: 0.75rem;
        padding: 1rem 1.5rem;
        background: #AEBCF8;
        color:rgb(43, 53, 99);
        border-radius: 0.5rem;
        cursor: pointer;
        font-weight: 600;
        font-size: 1rem;
        transition: all 0.2s ease;
        border: none;
        text-decoration: none;
        line-height: 1.2;
        width: 100%;
        max-width: inherit;
        justify-content: center;
      }

      .prescription-upload-label:hover {
        background: #9BA8F5;
        transform: translateY(-1px);
      }

      .prescription-file-input {
        position: absolute;
        width: 1px;
        height: 1px;
        padding: 0;
        margin: -1px;
        overflow: hidden;
        clip: rect(0, 0, 0, 0);
        white-space: nowrap;
        border: 0;
      }

      .prescription-button__icon svg {
        width: 20px;
        height: 20px;
        fill: currentColor;
      }

      .prescription-status {
        margin-top: 1rem;
        padding: 1rem;
        background: #f0fdf4;
        border: 1px solid #22c55e;
        border-radius: 0.5rem;
        animation: slideDown 0.3s ease-out;
      }

      .prescription-status__content {
        display: flex;
        align-items: flex-start;
        gap: 0.75rem;
      }

      .prescription-status__text {
        flex: 1;
        font-size: 0.9rem;
        color: #166534;
      }

      .prescription-status__remove {
        background: none;
        border: none;
        color: #dc2626;
        cursor: pointer;
        padding: 0.4rem;
        border-radius: 0.25rem;
        transition: background-color 0.2s ease;
        display: flex;
        align-items: center;
      }

      .prescription-status__remove:hover {
        background: rgba(220, 38, 38, 0.1);
      }

      @keyframes slideDown {
        from { opacity: 0; transform: translateY(-10px); }
        to { opacity: 1; transform: translateY(0); }
      }

      @media screen and (max-width: 749px) {
        .prescription-upload-label {
          font-size: 0.9rem;
          padding: 0.9rem 1.2rem;
          width: 100%;
          justify-content: center;
        }
        .prescription-button__icon svg {
          width: 18px;
          height: 18px;
        }
        .prescription-status__content {
          flex-direction: column;
          gap: 0.5rem;
        }
      }
    `;

    document.head.appendChild(style);
  }
}

// Inicializar
document.addEventListener('DOMContentLoaded', () => {
  new PrescriptionUpload();
  console.log('📄 Sistema de prescripciones: SOLO UI, NO interfiere con formulario');
}); 